import Helpers from './Helpers'

new Helpers(window).eventListener(() => {

    const images = [].slice.call(document.querySelectorAll('img[data-deferred="true"]'))
    const containers = [].slice.call(document.querySelectorAll('.deferred-images'))

    const canUseIntersection = 'IntersectionObserver' in window


    if (canUseIntersection) {
        // if "isIntersecting" is not present (Edge 15) add a polyfill
        if (!('isIntersecting' in IntersectionObserverEntry.prototype)) {
            Object.defineProperty(window.IntersectionObserverEntry.prototype, 'isIntersecting', {
                get: () => this.intersectionRatio > 0,
            })
        }

        const options = {
            rootMargin: '100px',
            threshold: 0,
        }

        const deferredImageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting || entry.intersectionRatio > 0) {
                    const img = entry.target
                    if (img.hasAttribute('data-src')) {
                        img.setAttribute('src', img.getAttribute('data-src'))
                        // Srcset Images
                        if (img.hasAttribute('data-srcset')) {
                            img.setAttribute('srcset', img.getAttribute('data-srcset'))
                            img.setAttribute('sizes', img.getAttribute('data-sizes'))

                            img.removeAttribute('data-srcset')
                            img.removeAttribute('data-sizes')
                        }
                        img.removeAttribute('data-src')
                        img.removeAttribute('data-deferred')
                    }
                    deferredImageObserver.unobserve(img)
                }
            })
        }, options)

        const deferredContainerObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting || entry.intersectionRatio > 0) {
                    const container = entry.target
                    const imgs = [].slice.call(container.querySelectorAll('img[data-deferred="true"]'))
                    imgs.forEach((img) => {
                        if (img.hasAttribute('data-src')) {
                            img.setAttribute('src', img.getAttribute('data-src'))
                            // Srcset Images
                            if (img.hasAttribute('data-srcset')) {
                                img.setAttribute('srcset', img.getAttribute('data-srcset'))
                                img.setAttribute('sizes', img.getAttribute('data-sizes'))

                                img.removeAttribute('data-srcset')
                                img.removeAttribute('data-sizes')
                            }
                            img.removeAttribute('data-src')
                            img.removeAttribute('data-deferred')
                        }
                        // unobserve the image once loaded
                        deferredImageObserver.unobserve(img)
                    })
                    container.classList.remove('deferred-images')
                    // unobserve the container once all images within are loaded
                    deferredContainerObserver.unobserve(container)
                }
            })
        }, options)

        // register observer to elements
        images.forEach((img) => {
            deferredImageObserver.observe(img)
        })

        containers.forEach((container) => {
            deferredContainerObserver.observe(container)
        })
    } else {
        images.forEach((img) => {
            img.setAttribute('src', img.getAttribute('data-src'))
            img.setAttribute('srcset', img.getAttribute('data-srcset'))
            img.setAttribute('sizes', img.getAttribute('data-sizes'))
            img.removeAttribute('data-src')
            img.removeAttribute('data-srcset')
            img.removeAttribute('data-sizes')
            img.removeAttribute('data-deferred')
        })
    }
}, 'load')
